import {useNavigate} from "react-router-dom";

export default function UpdateButtonMenu(props) {
    const navigate = useNavigate();

    return (
        <a href="#"
           onClick={(e) => {
               e.preventDefault();
               navigate("/manage-job/update-job/" + props.row.cos_job_id);
           }}
        >Update</a>
    );
}
